import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, HostBinding } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyPaginator } from '@angular/material/legacy-paginator';
import { PageEvent } from '@angular/material/paginator';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-mat-paginator-wrapper',
    standalone: true,
    imports: [CommonModule, MatLegacyFormFieldModule, MatLegacyInputModule, FontAwesomeModule, MatLegacyButtonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './mat-paginator-wrapper.component.html',
    styleUrls: ['./mat-paginator-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatPaginatorWrapperComponent {
    @HostBinding('class') cssClass = 'flex justify-end flex-wrap-reverse';
    @ContentChild(MatLegacyPaginator) paginator: MatLegacyPaginator;
    protected targetPageForm = new FormControl<number | null>(null, { validators: [(c: FormControl<number>) => (this.isValidPage(Number(c.value)) ? null : { invalidPageError: true })] });

    private isValidPage(_targetPage: number) {
        return !Number.isNaN(_targetPage) && _targetPage <= this.paginator?.getNumberOfPages();
    }
    protected onGoToPageClick() {
        const _targetPage = Number(this.targetPageForm.value);

        if (this.isValidPage(_targetPage)) {
            const targetIndex = _targetPage - 1;
            if (targetIndex !== this.paginator.pageIndex) {
                const pageEvent: PageEvent = {
                    pageIndex: targetIndex,
                    previousPageIndex: this.paginator.pageIndex,
                    pageSize: this.paginator.pageSize,
                    length: this.paginator.length,
                };
                this.paginator.pageIndex = targetIndex;
                this.paginator.page.emit(pageEvent);
            }
            this.targetPageForm.reset();
        }
    }
}
